import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Detailing Disciples | Premium Car Detailing in Los Angeles & Ventura County",
  description = "Premium mobile & shop car detailing serving Los Angeles, Ventura County, Santa Monica, Calabasas, Thousand Oaks, Encino, Northridge & Woodland Hills. Ceramic coating, paint correction, interior detailing. 5.0★ rated. Book: (747) 320-7174",
  canonical = "https://detailingdisciples.com",
  image = "https://detailingdisciples.com/og-image.jpg",
  type = "website"
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://detailingdisciples.com",
    "name": "Detailing Disciples",
    "image": image,
    "description": description,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "",
      "addressLocality": "Los Angeles",
      "addressRegion": "CA",
      "postalCode": "",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "34.0522",
      "longitude": "-118.2437"
    },
    "url": "https://detailingdisciples.com",
    "telephone": "+17473207174",
    "priceRange": "$$",
    "areaServed": [
      {
        "@type": "City",
        "name": "Los Angeles"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Ventura County"
      },
      {
        "@type": "City",
        "name": "Santa Monica"
      },
      {
        "@type": "City",
        "name": "Calabasas"
      },
      {
        "@type": "City",
        "name": "Thousand Oaks"
      },
      {
        "@type": "City",
        "name": "Encino"
      },
      {
        "@type": "City",
        "name": "Northridge"
      },
      {
        "@type": "City",
        "name": "Woodland Hills"
      }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Saturday", "Sunday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "11",
      "bestRating": "5",
      "worstRating": "1"
    },
    "sameAs": [
      "https://www.instagram.com/thedetailingdisciples",
      "https://www.facebook.com/profile.php?id=61574961796039",
      "https://www.yelp.com/biz/detailing-disciples-simi-valley-2",
      "https://www.tiktok.com/@detailing.discipl"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Car Detailing Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Basic Hand Wash",
            "description": "Professional hand wash with deionized RO water"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Premium Detail",
            "description": "Complete interior and exterior detailing with ceramic sealant"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Ceramic Coating",
            "description": "Professional ceramic coating with multi-year protection"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Paint Correction",
            "description": "3-step paint correction system"
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      
      {/* Keywords for Local SEO */}
      <meta name="keywords" content="car detailing Los Angeles, car detailing Ventura County, auto detailing Santa Monica, ceramic coating Calabasas, paint correction Thousand Oaks, mobile detailing Encino, car detailing Northridge, auto detailing Woodland Hills, ceramic coating near me, paint correction Los Angeles" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Detailing Disciples" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Detailing Disciples" />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="US-CA" />
      <meta name="geo.placename" content="Los Angeles, Ventura County" />
      <meta name="geo.position" content="34.0522;-118.2437" />
      <meta name="ICBM" content="34.0522, -118.2437" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
